import * as yup from 'yup';

export const editEmployerNameSchema = () => {
  return yup.object().shape({
    relocationEmployerName: yup.string().nullable(),
  });
};
